import { render } from "./remark-tags-list.vue?vue&type=template&id=8e54d296&scoped=true"
import script from "./remark-tags-list.vue?vue&type=script&lang=js"
export * from "./remark-tags-list.vue?vue&type=script&lang=js"

import "./remark-tags-list.vue?vue&type=style&index=0&id=8e54d296&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e54d296"]])

export default __exports__